import { htmlToPlainText } from '@/views/chats/utils/chatMessageContent.util.ts';

export const TEAM_ANNOUNCEMENTS_CHAT_NAME = 'ogłoszenia';

export const isTeamAnnouncementsChat = (name: string): boolean =>
  name === TEAM_ANNOUNCEMENTS_CHAT_NAME;

export const announcementPreview = (html: string): string =>
  htmlToPlainText(html).replace(/\s+/g, ' ').trim();
